import { render } from "./LpfooterView.vue?vue&type=template&id=dd2b0202"
import script from "./LpfooterView.vue?vue&type=script&lang=js"
export * from "./LpfooterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__